import api from "../api";
import {createError, logError, logSuccess} from "./message";
import types from "./types";
import {getPlanCard, getPlanList, getPlanMainInfo, getPlanSystemInfo} from "./actions";
import {getGroupCard, getGroupMain} from "../../Groups/store/actions";

function createPlanRequest() {
  return {
    type: types.CREATE_PLAN_REQUEST,
    isCreatingPlan: true
  };
}

function createPlanCompleted(createdPlan) {
  return {
    type: types.CREATE_PLAN_COMPLETED,
    isCreatingPlan: false,
    createdPlan
  };
}

function createPlanError(planCreationError) {
  return {
    type: types.CREATE_PLAN_ERROR,
    isCreatingPlan: false,
    planCreationError
  };
}

function createGroupRequest() {
  return {
    type: types.CREATE_GROUP_REQUEST,
    isCreatingGroup: true
  };
}

function createGroupCompleted(createdGroup) {
  return {
    type: types.CREATE_GROUP_COMPLETED,
    isCreatingGroup: false,
    createdGroup
  };
}

function createGroupError(groupCreationError) {
  return {
    type: types.CREATE_GROUP_ERROR,
    isCreatingGroup: false,
    groupCreationError
  };
}

function updateGroupRequest() {
  return {
    type: types.UPDATE_GROUP_REQUEST,
    isUpdatingGroup: true
  };
}

function updateGroupCompleted(updatedGroup) {
  return {
    type: types.UPDATE_GROUP_COMPLETED,
    isUpdatingGroup: false,
    updatedGroup
  };
}

function updateGroupError(groupUpdatingError) {
  return {
    type: types.UPDATE_GROUP_ERROR,
    isUpdatingGroup: false,
    groupUpdatingError
  };
}

export function createPlan(data) {
  return dispatch => {
    dispatch(createPlanRequest());
    return api
      .createPlan(data)
      .then(response => {
        if (response.status === 200) {
          dispatch(createPlanCompleted(response.data));
          dispatch(getPlanList());
          logSuccess("Новый план обучения успешно добавлен");
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(createPlanError(message));
        } else {
          logError(err);
          dispatch(createPlanError(createError("Не удалось отправить запрос добавления плана обучения")));
        }
      });
  };
}

export function createGroup(planId, data) {
  return dispatch => {
    dispatch(createGroupRequest());
    return api.createGroup(planId, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(createGroupCompleted(response.data));
          logSuccess("Новая группа успешно добавлена");
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(createGroupError(message));
        } else {
          logError(err);
          dispatch(createGroupError(createError("Не удалось отправить запрос добавления группы")));
        }
      });
  };
}

export function updateGroup(id, data) {
  return dispatch => {
    dispatch(updateGroupRequest());
    return api.updateGroup(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateGroupCompleted(response.data));
          logSuccess("Данные группы успешно обновлены");
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updateGroupError(message));
        } else {
          logError(err);
          dispatch(updateGroupError(createError("Не удалось отправить запрос обновление группы")));
        }
      });
  };
}

function updatePlanRequest() {
  return {
    type: types.UPDATE_PLAN_REQUEST,
    isUpdatingPlan: true
  };
}

function updatePlanCompleted(updatedPlan) {
  return {
    type: types.UPDATE_PLAN_COMPLETED,
    isUpdatingPlan: false,
    updatedPlan
  };
}

function updatePlanError(planUpdatingError) {
  return {
    type: types.UPDATE_PLAN_ERROR,
    isUpdatingPlan: false,
    planUpdatingError
  };
}

export function updatePlan(id, data) {
  return dispatch => {
    dispatch(updatePlanRequest());
    return api.updatePlan(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updatePlanCompleted(response.data));
          logSuccess("Данные потока успешно обновлены");
          dispatch(getPlanMainInfo(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updatePlanError(message));
        } else {
          logError(err);
          dispatch(updatePlanError(createError("Не удалось отправить запрос обновление данных потока")));
        }
      });
  };
}

function changeStatePlanRequest() {
  return {
    type: types.CHANGE_STATE_PLAN_REQUEST,
    isChangingPlanStatus: true
  };
}

function changeStatePlanCompleted(changedPlanStatus) {
  return {
    type: types.CHANGE_STATE_PLAN_COMPLETED,
    isChangingPlanStatus: false,
    changedPlanStatus
  };
}

function changeStatePlanError(changeStatePlanError) {
  return {
    type: types.CHANGE_STATE_PLAN_ERROR,
    isChangingPlanStatus: false,
    changeStatePlanError
  };
}

export function changePlanState(planId, type) {
  return dispatch => {
    dispatch(changeStatePlanRequest());
    return api.changeStatusPlan(planId, type)
      .then(response => {
        if (response.status === 200) {
          dispatch(changeStatePlanCompleted(response.data));
          dispatch(getPlanSystemInfo(planId));
          dispatch(getPlanMainInfo(planId));
          dispatch(getPlanCard(planId));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(changeStatePlanError(message));
        } else {
          logError(err);
          dispatch(changeStatePlanError(createError("Не удалось отправить запрос")));
        }
      });
  };
}

export default {
    createPlan,
    createGroup,
  updateGroup,
  updatePlan,
  changePlanState
}
